<template>
  <div class="add">
    <header-bar :is-user="true"></header-bar>
    <user-head></user-head>
    <section class="main" v-if="userToken">
      <h1 class="title">{{ currType=="add"?'发':'修改'}}文章</h1>
      <el-form
        :model="postForm"
        :rules="rules"
        ref="postForm"
        label-width="80px"
        class="addForm"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="postForm.title" placeholder="请输入标题，标题长度50个字以内" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="话题">
          <el-select v-model="postForm.topicId" placeholder="请选择话题（此项非必选）" @change="changeTopic" :clearable="clearable">
            <el-option
              v-for="item in topicList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="正文" prop="content" v-if="currType=='add'">
          <editor-bar v-model="detail" :content="postForm.content"  @change="change"></editor-bar>
        </el-form-item>
        <el-form-item label="正文" prop="content" v-if="currType=='edit'&&postForm.content">
          <editor-bar v-model="detail" :content="postForm.content"  @change="change"></editor-bar>
        </el-form-item>
        <el-form-item class="form-center">
          <el-button v-if="isLoading" type="primary" @click="submitForm('postForm')" class="play-btn" disabled>发布</el-button>
          <el-button v-else type="primary" @click="submitForm('postForm')" class="play-btn">发布</el-button>
          <el-button @click="resetForm('postForm')" class="cancel-btn">重置</el-button>
          <!-- <el-button @click="addDraft"  type="warning" plain>保存为草稿</el-button> -->
        </el-form-item>
      </el-form>
    </section>
    <section class="main" v-else>
      <h1 class="tips">请先登录！</h1>
      <div class="login">
        <el-button type="primary" @click="$router.push({path:'/login'})">去登录</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import UserHead from "@/components/UserHead.vue";
import EditorBar from '@/components/Editor.vue';
export default {
  name: "AddPosts",
  components: {
    HeaderBar,
    UserHead,
    EditorBar
  },
  data() {
    return {
      userToken: localStorage.getItem("UserToken"),
      addTypeFlag: false,
      channelDataList: [],
      topicList:[],
      postForm: {
        title: "",
        topicId: "",
        topicName:"",
        content: "",
        type: 0
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        topicId: [
          { required: true, message: "请选择话题", trigger: "change" }
        ],
        content: [{ required: true, message: "请完善正文", trigger: "blur" }]
      },
      myConfig: {
        UEDITOR_HOME_URL: "/static/ue/"
      },
      currId:'',
      currType:'',
      clearable: true,
      isLoading: false,
      detail:"",
    };
  },
  methods: {
    getTopics(){
      this.$api.topics()
        .then(res => {
          this.topicList = res.data.data;
        });
    },
    changeTopic(val){
      let obj = this.topicList.find(item=>{
        return item.id == val
      })
      this.postForm.topicName = obj?obj.name:"";
    },
    submitForm(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.$api[this.currType=='add'?'addPosts':'editPosts'](this.postForm).then(res => {
            window.localStorage.removeItem("formDataPost")
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000,
              onClose: function(){
                _this.$router.push('/user/personal/'+ JSON.parse(localStorage.getItem("UserInfo")).id)
              }
            });
            this.$refs[formName].resetFields();
          });
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.postForm.topicId = '';
      this.postForm.content = '';
      this.detail = '';
    },
    getInfo(){
      this.$api
        .articleDetail({
          id: this.currId
        })
        .then(res => {
          let data = res.data.data;
          let postForm = {
            id: data.id,
            title: data.title,
            topicId: data.topicId==0?'':data.topicId,
            topicName: data.topicId==0?'':data.topicName,
            content: data.content,
            type: 0
          }
          this.postForm = postForm
        });
    },
    addDraft(){
      window.localStorage.setItem("formDataPost",JSON.stringify(this.postForm))
      this.$message({
          message: '已保存为草稿',
          type: 'success'
      });
    },
    change(val) {
      this.postForm.content = val
    }
  },
  created() {
    this.getTopics()
    let type = this.$route.params.type;
    this.currType = type;
    if(type=="edit"){
      this.currId = this.$route.query.id;
      this.getInfo()
    }else{
      this.postForm = JSON.parse(window.localStorage.getItem("formDataPost"))||this.postForm;
    }
  },
  watch: {
    $route: {
      handler() {
          this.currType = this.$route.params.type;
          if(this.currType=="add"){
            let postForm = {
              title: "",
              content: "",
              type: 0
            }
            this.postForm = postForm
          }else{
            this.currId = this.$route.query.id;
            this.getInfo()
          }
          //深度监听，同时也可监听到param参数变化
      },
      deep: true,
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  background: #fff;
  padding: 26px;
  .title {
    font-size: 18px;
    line-height: 1;
    color: #121212;
    border-left: 4px solid #317DFF;
    padding-left: 10px;
  }
  .tips{
    font-size: 18px;
    line-height: 1;
    color: #121212;
    text-align: center;
    margin-top: 100px;
  }
  .login{
    text-align: center;
    margin-top: 20px;
    margin-bottom: 100px;
    .el-button{
      width: 100px;
      height: 40px;
      background: #317DFF; 
    }
  }
  .addForm {
    margin-top: 20px;
    margin-right: 55px;
    .el-select {
      display: block;
    }
    .form-center {
      text-align: center;
      .play-btn {
        width: 128px;
        height: 40px;
        background: #317DFF;
        border-radius: 4px;
        border: none;
      }
      .cancel-btn {
        width: 128px;
        height: 40px;
        background: #dddddd;
        border-radius: 4px;
        margin-left: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/addPosts.vue